import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { Input } from "@mui/material";

class ReportDashboardConstructorItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTitleEditing: false,
      title: null,
    };
  }

  onDelete() {
    const { dashboard, selectedCustomReportId, onDeleteCustomReportDahsboard } = this.props;

    onDeleteCustomReportDahsboard({ id: dashboard.id }, selectedCustomReportId);
  }

  onShift(number) {
    const { dashboard, selectedCustomReportId, onShiftCustomReportDahsboard } = this.props;
    onShiftCustomReportDahsboard({ id: dashboard.id, number: dashboard.number + number }, selectedCustomReportId);
  }

  onChangeTitle(value) {
    this.setState({ title: value });
  }

  onUpdateTitle() {
    const { title = null } = this.state;
    const { dashboard, onUpdateCustomReportDashboard, selectedCustomReportId } = this.props;

    const options = {
      id: dashboard.id,
      title: title ?? dashboard.title,
    };

    onUpdateCustomReportDashboard(options, selectedCustomReportId);

    this.setState({ isTitleEditing: false, title: null });
  }

  render() {
    const { dashboard } = this.props;
    const { isTitleEditing, title } = this.state;

    if (dashboard === null) {
      return <div className={styles.dashboardsItemContainer}></div>;
    }

    if (isTitleEditing) {
      return (
        <div className={styles.dashboardsItemContainer}>
          <Input
            fontSize="small"
            name="dashboardTitle"
            type="text"
            onChange={(e) => {
              this.onChangeTitle(e.target.value);
            }}
            defaultValue={title ?? dashboard.title}
            fullWidth={false}
            style={{ fontSize: "11px", width: "85%" }}
          />

          <div className={styles.dashboardsItemRightContainer}>
            <TooltipWrapper title={`Созранить наименование`} position="top">
              <SaveIcon
                fontSize="small"
                className={styles.reportTitleEditButton}
                onClick={(e) => {
                  e.stopPropagation();
                  this.onUpdateTitle();
                }}
              />
            </TooltipWrapper>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.dashboardsItemContainer}>
        <TooltipWrapper title={`Сменить порядок`} position="top">
          <SkipPreviousIcon
            fontSize="small"
            onClick={() => {
              if (dashboard.number > 1) {
                this.onShift(-1);
              }
            }}
          />
        </TooltipWrapper>

        <div className={styles.dashboardsItemTitle}>
          <div>
            {dashboard.title} {dashboard.measure != null ? `(${dashboard.measure})` : null}
          </div>
          <div></div>
        </div>

        <div className={styles.dashboardsItemRightContainer}>
          <TooltipWrapper title={`Изменить наименование `} position="top">
            <EditIcon
              fontSize="inherit"
              className={styles.reportTitleEditButton}
              onClick={(e) => {
                e.stopPropagation();
                this.setState({ isTitleEditing: true });
              }}
            />
          </TooltipWrapper>

          <TooltipWrapper title={`Сменить порядок `} position="top">
            <SkipNextIcon
              fontSize="small"
              onClick={() => {
                this.onShift(1);
              }}
            />
          </TooltipWrapper>

          <TooltipWrapper title={`Удалить ${dashboard.title}`} position="top">
            <DeleteOutlineIcon
              fontSize="small"
              onClick={(e) => {
                e.stopPropagation();
                this.onDelete();
              }}
            />
          </TooltipWrapper>
        </div>
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportDashboardConstructorItem)));
